import type { StoneShapeFragment } from '@/graphql/api'
import { computed, type ComputedRef, toValue } from 'vue'
import { includes, type RefOrGetter } from '@/helpers'
import { allowedShapes } from '@/domain/stone/search/allowed-shapes.ts'

export function useAllowedShapes(
    shapes: RefOrGetter<StoneShapeFragment[] | undefined>
): ComputedRef<StoneShapeFragment[] | undefined> {
    return computed(() => {
        return toValue(shapes)?.filter((s) =>
            includes(allowedShapes, s.systemCode)
        )
    })
}
